export default {
  // Product photos arrive as `data-src` and are fetched for the board on
  // show and its neighbours, so opening a deck does not fetch every photo
  // in it (DeckHelper#deck_photo).
  hydrate(index) {
    for (let i = index - 1; i <= index + 1; i++) {
      this.slideTargets[i]?.querySelectorAll("img[data-src]").forEach((img) => {
        img.src = img.dataset.src;
        delete img.dataset.src;
      });
    }
  },

  hydrateAll() {
    this.element.querySelectorAll("img[data-src]").forEach((img) => {
      img.src = img.dataset.src;
      delete img.dataset.src;
    });
  },
};
